import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../Redux/Slices/adminPortalSlice';
import './Charts.css';



const options = {
    responsive: true,
    maintainAspectRatio: false,
    barPercentage: 0.6,
    // categoryPercentage: 3,
    plugins: {
        legend: {
            labels: {
                padding: 10
            }
        },
        title: {
            display: true,
            text: 'Average Score',
            font: {
                size: 20,
            },
        },
    },
    scales: {
        x: {  // not 'yAxes: [{' anymore (not an array anymore)
            grid: { display: false },
            ticks: {
                // color: "green", // not 'fontColor:' anymore
                // fontSize: 18,
                font: {
                    size: 20, // 'size' now within object 'font {}'
                },
                // stepSize: 25,
                beginAtZero: true,
                // callback: function (value) {
                //     return (value)+'%'; // convert it to percentage
                // },

            }
        },
        y: {
            grid: { display: true },
            ticks: {
                // color: "green", // not 'fontColor:' anymore
                // fontSize: 18,
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                font: {
                    size: 20, // 'size' now within object 'font {}'

                },
                // stepSize: 1,
                beginAtZero: true,
            }
        }
    },
};

const StackedChart = () => {
    let fetchedData = useSelector(analysisData);
    return (
        <div className="stackedChart_Div">
            <Bar className="stackedChart" data={get_data(fetchedData.episodeAnalysis)} options={options} />
        </div>
    );
}
export default StackedChart;


function get_data(episodeAnalysis) {
    let episode1_avgScore = episodeAnalysis.episode1.episode1_AvgScore;
    let episode2_avgScore = episodeAnalysis.episode2.episode2_AvgScore;
    let episode3_avgScore = episodeAnalysis.episode3.episode3_AvgScore;

    let episode1_avgScore_completed = episodeAnalysis.episode1.episode1_Completed_AvgScore;
    let episode2_avgScore_completed = episodeAnalysis.episode2.episode2_Completed_AvgScore;
    let episode3_avgScore_completed = episodeAnalysis.episode3.episode3_Completed_AvgScore;



    const data = {
        labels: ['Episode 1', 'Episode 2', 'Episode 3'],
        datasets: [
            {
                label: 'Average score',
                data: [episode1_avgScore, episode2_avgScore, episode3_avgScore],
                backgroundColor: [
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
            },
            {
                label: 'Average score of completed users',
                data: [episode1_avgScore_completed, episode2_avgScore_completed, episode3_avgScore_completed],
                backgroundColor: [
                    'rgba(245, 0, 87, 0.2)',
                ],
                borderColor: [
                    'rgba(245, 0, 87, 1)',
                ],
                borderWidth: 1,
            }
        ],
    };

    return (data);
}